<template>
    <div class="columns">
        <div class="column d-flex flex-column" v-for="(plan, index) in plans">
            <div class="card card-subscription h-100">
                <div class="card__heading border-radius-top bg-navy pt-5 pb-3 text-center shape shape--top-large">
                    <div class="fs-18 t-orange lh-lg font-weight-semi-bold mb-1">{{plan.name}}</div>
                    <div class="">
                        <div class="h1 t-white">&pound;{{plan.price}}</div>
                        <span class="h6 font-weight-normal t-disabled text-uppercase">Per Month</span>
                    </div>
                </div>
                <div class="card__content p-1 p-sm-3 pt-4">
                    <ul class="px-2">
                        <template v-for="(feature, i) in plan.features">
                            <li class="li-check font-weight-light lh-lg"
                                :class="{'mb-12px' : i !== plan.features.length}">{{feature}}
                            </li>
                        </template>
                    </ul>
                </div>
                <div class="p-2 p-sm-3 mt-auto">
                    <slot name="buttonOne" v-if="index === 0"></slot>
                    <slot name="buttonTwo" v-if="index === 1"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CatUxoSubscriptions',
        props: {
            plans: {
                type: Array,
                required: true
            }
        },
        mounted() {
        }
    }
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/js/components/Subscriptions.vue